import { Question } from '../types';

// ============================================
// Section 1: Care Recipient Questions
// ============================================
export const careRecipientQuestions: Question[] = [
  {
    question: 'Wie ist der Familienname des pflegebedürftigen Antragstellers?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'lastName',
  },
  {
    question: 'Und wie ist der Vorname?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'name',
  },
  {
    question: 'Dann brauche ich bitte das Geburtsdatum.',
    answers: '',
    type: 'birthday',
    required: false,
    questionKey: 'birthday',
  },
  {
    question: 'Danke! In welcher Strasse wohnt der Pflegebedürftige?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'address',
  },
  {
    question: 'Und wie ist die Hausnummer?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'houseNumber',
  },
  {
    question: 'Können Sie mir bitte noch die Postleitzahl des Pflegebedürftigen nennen?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'zipCode',
  },
  {
    question: 'Und den Ort.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'city',
  },
  {
    question:
      'Nur wenn Sie möchten, können Sie für Rückfragen eine Telefonnummer angeben.',
    answers: '',
    type: 'phoneNumber',
    required: false,
    questionKey: 'phoneNumber',
  },
  {
    question:
      'Bei welcher Krankenversicherung ist der Pflegebedürftige? Bitte wählen Sie aus der Liste aus. Keine Eile, ich trinke solange meinen Espresso.',
    answers: '',
    type: 'option',
    required: false,
    questionKey: 'insurance',
  },
  {
    question: 'Super! Geben Sie mir bitte die Versichertennummer des Pflegebedürftigen.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'insuranceNumber',
  },
  {
    question:
      'Wurde bereits ein Pflegegrad erteilt? Wenn ja, welcher? Bitte wählen Sie aus der Liste aus.',
    answers: '',
    returnQuestion: '',
    type: 'rate',
    required: true,
    questionKey: 'levelOfCare',
  },
  {
    question: 'Wenn Sie möchten, können Sie eine Kopie des Pflegegradbescheids hochladen.',
    answers: '',
    type: 'file',
    required: false,
    questionKey: 'certificate',
    fileName: '',
  },
  {
    question: 'Steht der Pflegebedürftige unter gesetzlicher Betreuung?',
    answers: '',
    type: 'submit',
    required: true,
    questionKey: 'legalRepresentation',
  },
];

// ============================================
// Section 2: Legal Representative Questions
// ============================================
export const legalRepresentativeQuestions: Question[] = [
  {
    question: 'Gut, kein Problem! Wie ist der Familienname des Betreuers?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'lastName',
  },
  {
    question: 'Und wie ist der Vorname?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'name',
  },
  {
    question: 'Danke! In welcher Strasse wohnt oder arbeitet der Betreuer?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'address',
  },
  {
    question: 'Und bitte noch die Hausnummer.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'houseNumber',
  },
  {
    question: 'Können Sie mir bitte die Postleitzahl des Betreuers nennen?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'zipCode',
  },
  {
    question: 'Und den Ort.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'city',
  },
  {
    question: 'Für Rückfragen geben Sie bitte eine Telefonnummer an.',
    answers: '',
    type: 'phoneNumber',
    required: false,
    questionKey: 'phoneNumber',
  },
  {
    question: 'Wenn Sie möchten, können Sie eine Kopie der Betreuungsverfügung hochladen.',
    answers: '',
    type: 'file',
    required: false,
    questionKey: 'document',
    fileName: '',
  },
];

// ============================================
// Section 3: Prevented Caregiver Questions
// ============================================
export const preventedCaregiverQuestions: Question[] = [
  {
    question:
      'Wie ist der Familienname der Person, die üblicherweise pflegt und verhindert war oder ist?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'lastName',
  },
  {
    question: 'Und der Vorname?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'name',
  },
  {
    question:
      'Dann brauche ich bitte deren Geburtsdatum. Ich weiss, viele Fragen, tut mir leid.',
    answers: '',
    type: 'birthDay',
    required: false,
    questionKey: 'birthday',
  },
  {
    question: 'Danke! In welcher Strasse wohnt die Person, die verhindert ist?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'address',
  },
  {
    question: 'Und wie ist die Hausnummer?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'houseNumber',
  },
  {
    question: 'Können Sie mir bitte noch die Postleitzahl nennen?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'zipCode',
  },
  {
    question:
      'Und den Ort. Habe ich schon mal gefragt, aber hier geht es nun um die pflegende Person. Muss ich leider fragen, die deutschen Gesetze mal wieder...',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'city',
  },
  {
    question:
      'Nur wenn Sie möchten, können Sie für Rückfragen die Telefonnummer der üblicherweise pflegenden Person angeben.',
    answers: '',
    type: 'phoneNumber',
    required: false,
    questionKey: 'phoneNumber',
  },
  {
    question:
      'Wird die verhinderte Pflegeperson vom Pflegebedürftigen als Pfleger bezahlt oder ist sogar eine Pflegefirma?',
    answers: '',
    returnQuestion: '',
    type: 'submit',
    required: true,
    questionKey: 'isProfessionalCarer',
    defaultAnswer: 'Nein',
  },
  {
    question: 'Wie lange hat die verhinderte Pflegeperson schon den Antragsteller gepflegt?',
    answers: '',
    type: 'submit',
    required: true,
    questionKey: 'carePeriod',
  },
  {
    question:
      'Ab wann ist die normalerweise pflegende Person verhindert oder verhindert gewesen?',
    answers: '',
    type: 'date',
    required: true,
    questionKey: 'absenceStartDate',
  },
  {
    question: 'Und bis wann?',
    answers: '',
    type: 'date',
    required: true,
    questionKey: 'absenceEndDate',
  },
  {
    question: 'Weshalb ist die Person verhindert? Bitte wählen Sie einen Grund aus der Liste aus.',
    answers: '',
    type: 'option',
    required: true,
    questionKey: 'absenceReason',
  },
];

// ============================================
// Section 4: Substitute Caregiver Questions
// ============================================
export const substituteCaregiverQuestions: Question[] = [
  {
    question: 'Wie lautet der Familienname der Vertretung?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'lastName',
  },
  {
    question: 'Und der Vorname?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'name',
  },
  {
    question: 'Danke! In welcher Strasse wohnt die Vertretung?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'address',
  },
  {
    question: 'Und wie ist die Hausnummer?',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'houseNumber',
  },
  {
    question: 'Können Sie mir bitte noch die Postleitzahl nennen?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'zipCode',
  },
  {
    question: 'Und den Ort. Sie wissen ja, deutsche Gesetze...',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'city',
  },
  {
    question:
      'Nur wenn Sie möchten, können Sie für Rückfragen die Telefonnummer der Vertretung angeben.',
    answers: '',
    type: 'phoneNumber',
    required: false,
    questionKey: 'phoneNumber',
  },
  {
    question:
      'Steht die Vertretung neben dem Antragsteller noch anderen Personen als Pfleger gegen Bezahlung zur Verfügung, z.B. auch als pflegerischer Angestellter bei einem Pflegedienst?',
    answers: '',
    returnQuestion: '',
    type: 'submit',
    required: true,
    questionKey: 'isPaidByOthers',
  },
  {
    question:
      'Ist die Vertretung gewerblich als Pflegefachkraft tätig oder sogar eine Pflegefirma?',
    answers: '',
    returnQuestion: '',
    type: 'submit',
    required: true,
    questionKey: 'isCommerciallyActive',
  },
  {
    question:
      'Ist die Vertretung mit dem Antragsteller verwandt? Bitte wählen Sie aus der Liste.',
    answers: '',
    type: 'option',
    required: true,
    questionKey: 'relationshipType',
  },
  {
    question:
      'Ist die Vertretung mit dem Antragsteller verschwägert? Bitte wählen Sie aus der Liste.',
    answers: '',
    type: 'option',
    required: true,
    questionKey: 'marriageRelationship',
  },
  {
    question: 'Leben Vertretung und Antragsteller im selben Haushalt?',
    answers: '',
    type: 'submit',
    required: true,
    questionKey: 'sameHousehold',
  },
  {
    question: 'Wie oder wo haben Sie die Vertretung gefunden?',
    answers: '',
    type: 'option',
    required: true,
    questionKey: 'howFound',
  },
];

// ============================================
// Section 5: Commercial Provider Questions
// ============================================
export const commercialProviderQuestions: Question[] = [
  {
    question: '',
    answers: { date: '', duration: '', amount: '' },
    type: 'group',
    required: false,
    questionKey: 'availableDates',
  },
  {
    question: 'War die abwesende Pflegeperson den ganzen Tag verhindert?',
    answers: '',
    type: 'submit',
    required: false,
    questionKey: 'durationOfAbsence',
  },
  {
    question: 'Wie ist der Name des Kontoinhabers, der die Rückerstattung erhalten soll',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'accountHolderName',
  },
  {
    question:
      'Und die IBAN? Ich verstehe, wenn Sie diese Daten nicht mit mir teilen wollen. Bitte vergessen Sie nur dann nicht, die Angaben nachher im Ausdruck nachzutragen.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'iban',
  },
  {
    question: 'Bank',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'bank',
  },
  {
    question: 'Ich stimme der Datenverarbeitung, vor allem nach § 67 III SGB X zu.',
    type: 'constant',
    required: true,
    questionKey: 'dataProcessingConsent',
    answers: '',
  },
  {
    question:
      'Ich stimme zu, dass die Daten in Erfüllung der Aufgaben nach § 94 I Nr. 3 SGB XI verarbeitet werden. Sie sind erforderlich zur Prüfung des Anspruchs auf Verhinderungspflege nach § 39 SGB XI und erfordern die Mitwirkung nach § 60 SGB I. Mir ist bekannt, dass ohne Mitwirkung über den Anspruch nicht entschieden werden kann (§§ 33 I SGB XI, 60 I, 66 I SGB I). Mir ist bekannt, dass ich Allgemeine Informationen zur Datenverarbeitung und zu meinen Rechten von der Krankenkasse erhalten kann, wenn ich dies möchte. Die Angabe meiner Telefonnummer erfolgte freiwillig. Ich stimme zu, falls ich sie gegeben habe, dass ich bei Rückfragen telefonisch erreicht werden darf.',
    type: 'iAgree',
    required: true,
    questionKey: 'termsAgreement',
    answers: '',
  },
  {
    question:
      'Ich habe alle Informationen freiwillig unter Zuhilfenahme der Dienste der FLEXXI Care Deutschland GmbH eingetragen und berechtige diese Firma, sie zum Zweck der Datenverarbeitung zu verwenden, insbesondere Ausdrucke für mich zu erstellen. Ich stelle FLEXXI Care von jeder Haftung, auch für fehlerhafte Übermittlung, frei. Ich habe vor Absendung die Verpflichtung, alle Unterlagen zu kontrollieren.',
    type: 'iHave',
    required: true,
    questionKey: 'flexxiConsent',
    answers: '',
  },
  {
    question: 'Ich bestätige, daß der Betrag ausbezahlt wurde.',
    type: 'paid',
    required: true,
    questionKey: 'paymentConfirmation',
    answers: '',
  },
];

// ============================================
// Section 6: Private Individual Questions
// ============================================
export const privateIndividualQuestions: Question[] = [
  {
    question: '',
    answers: { date: '', duration: '', amount: '' },
    type: 'group',
    required: false,
    questionKey: 'availableDates',
  },
  {
    question: 'War die abwesende Pflegeperson den ganzen Tag verhindert?',
    answers: '',
    type: 'submit',
    required: false,
    questionKey: 'durationOfAbsence',
  },
  {
    question: 'Sind Kosten für die Anreise angefallen?',
    answers: '',
    type: 'submit',
    required: false,
    questionKey: 'hasTravelCosts',
  },
  {
    question: 'Wieviele km musste die Vertretung fahren?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'distanceKm',
  },
  {
    question: 'Von Postleitzahl und Stadt',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'originLocation',
  },
  {
    question: 'Nach Postleitzahl und Stadt',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'destinationLocation',
  },
  {
    question: 'Welche Anfahrtskosten sind nachweislich angefallen?',
    answers: '',
    type: 'number',
    required: false,
    questionKey: 'travelCost',
  },
  {
    question: 'Bitte laden Sie den Beleg hoch.',
    answers: '',
    type: 'file',
    required: false,
    questionKey: 'receiptUpload',
  },
  {
    question: 'Hatte die einspringende Person durch die Vertretung einen Verdienstausfall?',
    answers: '',
    type: 'submit',
    required: true,
    questionKey: 'hasEarningsLoss',
  },
  {
    question: 'In welcher Höhe?',
    answers: '',
    type: 'number',
    required: true,
    questionKey: 'earningsLossAmount',
  },
  {
    question: 'Wie ist der Name des Kontoinhabers, der die Rückerstattung erhalten soll',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'accountHolderName',
  },
  {
    question:
      'Und die IBAN? Ich verstehe, wenn Sie diese Daten nicht mit mir teilen wollen. Bitte vergessen Sie nur dann nicht, die Angaben nachher im Ausdruck nachzutragen.',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'iban',
  },
  {
    question: 'Bank',
    answers: '',
    type: 'text',
    required: false,
    questionKey: 'bank',
  },
  {
    question: 'Ich stimme der Datenverarbeitung, vor allem nach § 67 III SGB X zu.',
    type: 'constant',
    required: true,
    questionKey: 'dataProcessingConsent',
    answers: '',
  },
  {
    question:
      'Ich stimme zu, dass die Daten in Erfüllung der Aufgaben nach § 94 I Nr. 3 SGB XI verarbeitet werden. Sie sind erforderlich zur Prüfung des Anspruchs auf Verhinderungspflege nach § 39 SGB XI und erfordern die Mitwirkung nach § 60 SGB I. Mir ist bekannt, dass ohne Mitwirkung über den Anspruch nicht entschieden werden kann (§§ 33 I SGB XI, 60 I, 66 I SGB I). Mir ist bekannt, dass ich Allgemeine Informationen zur Datenverarbeitung und zu meinen Rechten von der Krankenkasse erhalten kann, wenn ich dies möchte. Die Angabe meiner Telefonnummer erfolgte freiwillig. Ich stimme zu, falls ich sie gegeben habe, dass ich bei Rückfragen telefonisch erreicht werden darf.',
    type: 'iAgree',
    required: true,
    questionKey: 'termsAgreement',
    answers: '',
  },
  {
    question:
      'Ich habe alle Informationen freiwillig unter Zuhilfenahme der Dienste der FLEXXI Care Deutschland GmbH eingetragen und berechtige diese Firma, sie zum Zweck der Datenverarbeitung zu verwenden, insbesondere Ausdrucke für mich zu erstellen. Ich stelle FLEXXI Care von jeder Haftung, auch für fehlerhafte Übermittlung, frei. Ich habe vor Absendung die Verpflichtung, alle Unterlagen zu kontrollieren.',
    type: 'iHave',
    required: true,
    questionKey: 'flexxiConsent',
    answers: '',
  },
  {
    question: 'Ich bestätige, daß der Betrag ausbezahlt wurde.',
    type: 'paid',
    required: true,
    questionKey: 'paymentConfirmation',
    answers: '',
  },
];

// ============================================
// Robot Messages
// ============================================
export const robotMessages = {
  welcome: 'Hallo! Ich bin FLEXX-i, der kleine Roboter, der für Sie die Formulare ausfüllt.',
  startQuiz: 'Lassen Sie uns beginnen. Ich werde Ihnen einige Fragen stellen.',
  sectionComplete: 'Super gemacht! Weiter geht es mit dem nächsten Abschnitt.',
  finalComplete:
    'Es ist geschafft!!! Danke für Ihre Geduld. Sie bekommen den Antrag nun per E-Mail zugeschickt.',
  levelOfCareStop:
    'Leider muss ein Pflegegrad vorliegen, damit ein Antrag auf Verhinderungspflege gestellt werden kann.',
  professionalCarerStop:
    'Leider können wir bei beruflichen Pflegekräften keinen Antrag erstellen.',
  carePeriodStop:
    'Leider muss die Pflege mindestens 6 Monate stattgefunden haben, bevor ein Antrag gestellt werden kann.',
};

// ============================================
// Dropdown Options
// ============================================
export const insuranceOptions = [
  'AOK Baden-Württemberg',
  'AOK Bayern',
  'AOK Bremen/Bremerhaven',
  'AOK Hessen',
  'AOK Niedersachsen',
  'AOK Nordost',
  'AOK Nordwest',
  'AOK Plus (Sachsen/Thüringen)',
  'AOK Rheinland/Hamburg',
  'AOK Rheinland-Pfalz/Saarland',
  'AOK Sachsen-Anhalt',
  'Barmer',
  'DAK Gesundheit',
  'TK (Techniker Krankenkasse)',
  'KKH (Kaufmännische Krankenkasse)',
  'HEK (Hanseatische Krankenkasse)',
  'hkk (Handelskrankenkasse)',
  'IKK Brandenburg und Berlin',
  'IKK Classic',
  'IKK Gesund Plus',
  'IKK Nord',
  'IKK Südwest',
  'BIG direkt gesund',
  'Knappschaft',
  'Andere',
];

export const levelOfCareOptions = [
  { label: 'Kein Pflegegrad', value: 'none' },
  { label: 'Pflegegrad 1', value: '1' },
  { label: 'Pflegegrad 2', value: '2' },
  { label: 'Pflegegrad 3', value: '3' },
  { label: 'Pflegegrad 4', value: '4' },
  { label: 'Pflegegrad 5', value: '5' },
];

// Options matching legacy app: reasonsOfAbsence
export const absenceReasonOptions = [
  'Ruhetag (zB wegen Erschöpfung, religiöser Feiertag)',
  'Erhlolungsurlaub',
  'Krankenhaus-/Reha/Kuraufenthalt',
  'Dienstreise',
  'eigene längere Krankheit',
  'Krankheit einer nahestehenden Person',
  'eigene kurzfristige Krankheit',
  'dienstliche Verpflichtung',
  'Arztbesuch',
  'Private Abwesenheit (Theaterbesuch, Familienfeier, Frisör) mit positiver Wirkung auf das eigene Allgemeinbefinden oder das einer dritten Person',
  'sonstige, moralisch erforderliche Abwesenheit, die einem Dritten oder der Pflegenden Person zur Hilfe dient',
  'Besuch einer Fortbildung',
];

// Options matching legacy app: relationshipList
export const relationshipOptions = [
  'nicht verwandt',
  'Verwandt 1 Grad : Vater, Mutter, Sohn oder Tochter des Berechtigten',
  'Verwandt 2. Grades: Schwester, Bruder, Grossmutter, Grossvater, Enkeltochter oder Enkelsohn des Berechtigten',
  'andere Verwandtschaft',
];

// Options matching legacy app: relationshipByMarriageList
export const marriageRelationshipOptions = [
  'Nicht verheiratet oder verschwägert',
  'Ehepartner oder eingetragener Lebenspartner',
  'Verschwägert 1a) Ehepartner / Lebenspartner von Vater Mutter Sohn Tochter des Berechtigten',
  'Verschwägert 1b) Vater Mutter Sohn Tochter des Ehepartner / Lebenspartners des Berechtigten',
  'Verschwägert 2a) Ehepartner von Schwester Bruder Grossmutter Grossvater Enkeltochter Enkelsohn des Berechtigten',
  'Verschwägert 2b) Schwester Bruder Grossmutter Grossvater Enkeltochter Enkelsohn des Ehepartnes / Lebenspartners des Berechtigten',
  'Anders verwandt oder verschwägert',
];

// Options matching legacy app: otherRelationshipList
export const howFoundOptions = [
  'durch Dritte vermittelte Pflege, zB FLEXXI Pflegekraft',
  'Pflegefirma',
  'Nachbar, auch wenn im selben Haus aber nicht im gleichen Haushalt lebend',
  'Anderer Bekannter oder Nachbar',
  'Verwandt oder Verschwägert',
];

